// extracted by mini-css-extract-plugin
module.exports = {"direction":"_93444fe79c--direction--2zyZA","direction-title":"_93444fe79c--direction-title--2GEgL","direction-meta":"_93444fe79c--direction-meta--3D8AK"};